import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'logistics_hongde_driver_page',
  data: function data() {
    return {
      dayjs: dayjs,
      currentUser: localStorage.getItem('userId'),
      pageConfig: {
        editPageName: '司机',
        queryDriverAuditFunName: 'logisticHongdeDriverAuditQuery',
        addDriverAuditFunName: 'logisticHongdeDriverAuditAdd',
        modifyDriverFunName: 'logisticHongdeDriverModify',
        queryDriverFunName: 'logisticHongdeDriverQuery',
        detailDriverFunName: 'logisticHongdeDriverDetail',
        dicTreeFunName: 'mngDictionaryLowerTree',
        carTeamFunName: 'logisticHongdeCarTeamQuery',
        EvalSwitchName: 'logisticHongdeDriverEvaSwitch',
        successDriverFunNane: 'logisticHongdeDriverSuccess',
        failDriverFunNane: 'logisticHongdeDriverFail',
        disableFunName: 'mngUserDisable',
        unDisableFunName: 'mngUserUnDisable',
        clearAuthFunName: 'mngUserClearAuth'
      },
      searchForm: {
        page: 1,
        limit: 10,
        authState: null,
        searchKey: null,
        userState: null,
        sortField: 'create_time'
      },
      driverFormData: {
        id: null,
        name: null,
        contactPhone: null,
        identityCard: null,
        identityCardImageFront: null,
        identityCardImageBack: null,
        carCategory: null,
        carNumber: null,
        carTeam: null,
        drivingLicenceImage: null,
        vehicleLicense: null,
        insurancePolicyImage: null,
        insurancePolicyImageArray: [],
        carImage: null,
        carImageArray: []
      },
      driversRules: {
        name: [{
          required: true,
          message: '姓名不能为空',
          trigger: 'blur'
        }],
        contactPhone: [{
          required: true,
          message: '联系电话不能为空',
          trigger: 'blur'
        }],
        identityCard: [{
          required: true,
          message: '身份证号不能为空',
          trigger: 'blur'
        }],
        carCategory: [{
          required: true,
          message: '车辆类型不能为空',
          trigger: 'blur'
        }],
        carNumber: [{
          required: true,
          message: '车辆牌号不能为空',
          trigger: 'blur'
        }],
        carTeam: [{
          required: true,
          message: '所属车队不能为空',
          trigger: 'blur'
        }],
        drivingLicenceImage: [{
          required: true,
          message: '驾驶证不能为空',
          trigger: 'blur'
        }],
        vehicleLicense: [{
          required: true,
          message: '行驶证不能为空',
          trigger: 'blur'
        }]
        // , insurancePolicyImageArray: [
        //   { required: true, message: '箱货保险单不能为空', trigger: 'blur' }
        // ]
        // , carImageArray: [
        //   { required: true, message: '车辆照片不能为空', trigger: 'blur' }
        // ]
        // , identityCardImageFront: [
        //   { required: true, message: '身份证正面不能为空', trigger: 'blur' }
        // ]
        // , identityCardImageBack: [
        //   { required: true, message: '身份证反面不能为空', trigger: 'blur' }
        // ]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogTitle: null,
      editDriverDialogShow: false,
      formLabelWidth: '120px',
      emptyDriverFormData: {},
      successFormData: {},
      dicData: {
        upperCode: 'logistics_hd_car_type',
        configCarTypes: [],
        configCarTypeOptions: {},
        levelUpperCode: 'logistics_hd_driver_level',
        configLevels: [],
        configLevelOptions: {}
      },
      carTeamData: {
        configCarTeams: [],
        configCarteamOptions: {}
      },
      successData: {
        successCarTeam: null,
        successRowId: null
      },
      successDialogShow: false,
      rowCarInfo: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.emptyDriverFormData = JSON.parse(JSON.stringify(this.driverFormData));
    Promise.all([new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.upperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configCarTypes = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configCarTypeOptions[res.data[i].code] = res.data[i].name;
          }
        }
        resolve(res);
      });
    }), new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.levelUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configLevels = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configLevelOptions[res.data[i].code] = res.data[i].name;
          }
        }
        resolve(res);
      });
    }), new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.carTeamFunName]().then(function (res) {
        if (res.data) {
          _this.carTeamData.configCarTeams = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.carTeamData.configCarteamOptions[res.data[i].id] = res.data[i].name;
          }
        }
        resolve(res);
      });
    })]).then(function (result) {
      _this.query();
    });
  },
  methods: {
    beforeCommand: function beforeCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command
      };
    },
    moreButton: function moreButton(command) {
      switch (command.command) {
        case 'disable':
          // 封禁用户
          this.disableUser(command.row.userId);
          break;
        case 'unDisable':
          // 解封用户
          this.unDisableUser(command.row.userId);
          break;
        case 'clear':
          // 清理用户
          this.clearUser(command.row.userId);
          break;
        case 'unEval':
          // 禁用评价
          this.operateEval(command.row.id, false);
          break;
        case 'eval':
          // 开启评价
          this.operateEval(command.row.id, true);
          break;
        case 'success':
          // 通过
          this.success(command.row.id);
          break;
        case 'fail':
          // 拒绝
          this.fail(command.row.id);
          break;
        case 'seeEval':
          // 查看评价
          this.seeEval(command.row);
          break;
      }
    },
    disableUser: function disableUser(userId) {
      var _this2 = this;
      this.$confirm('确定封禁当前司机吗').then(function () {
        _this2.$api[_this2.pageConfig.disableFunName](userId).then(function (res) {
          if (res.data) {
            _this2.$message.success('封禁成功');
            _this2.query();
          } else {
            _this2.$message.error('封禁失败');
          }
        });
      });
    },
    unDisableUser: function unDisableUser(userId) {
      var _this3 = this;
      this.$confirm('确定解禁当前司机吗').then(function () {
        _this3.$api[_this3.pageConfig.unDisableFunName](userId).then(function (res) {
          if (res.data) {
            _this3.$message.success('解禁成功');
            _this3.query();
          } else {
            _this3.$message.error('解禁失败');
          }
        });
      });
    },
    clearUser: function clearUser(userId) {
      var _this4 = this;
      this.$confirm('确定清除用户吗？用户清除后将不能恢复').then(function () {
        _this4.$confirm('请再次确认，是否清除当前用户？').then(function () {
          _this4.$confirm('请谨慎操作！！！最后确认是否清除当前用户？').then(function () {
            _this4.$api[_this4.pageConfig.clearAuthFunName](userId).then(function (res) {
              if (res.data) {
                _this4.$message.success('清除成功');
                _this4.query();
              } else {
                _this4.$message.error('清除失败');
              }
            });
          });
        });
      });
    },
    operateEval: function operateEval(id, flag) {
      var _this5 = this;
      this.$confirm(flag ? '确定开启评价吗?' : '确定关闭评价吗?').then(function () {
        _this5.$api[_this5.pageConfig.EvalSwitchName](id, flag).then(function (res) {
          if (res.data) {
            _this5.$message.success(flag ? '开启成功' : '关闭成功');
            _this5.query();
          } else {
            _this5.$message.error(flag ? '开启失败' : '关闭失败');
          }
        });
      });
    },
    success: function success(id) {
      var _this6 = this;
      this.successData.successRowId = id;
      this.$api[this.pageConfig.detailDriverFunName](id).then(function (res) {
        _this6.rowCarInfo = res.data;
        _this6.successData.successCarTeam = res.data.carTeam;
        _this6.successDialogShow = true;
      });
    },
    fail: function fail(id) {
      var _this7 = this;
      this.$prompt('请填写驳回的原因', '驳回认证', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: '请填写驳回原因'
      }).then(function (_ref) {
        var value = _ref.value;
        _this7.$api[_this7.pageConfig.failDriverFunNane](id, value).then(function (res) {
          _this7.$message.success('操作成功');
          _this7.query();
        });
      }).catch(function () {});
    },
    seeEval: function seeEval(id) {
      this.goChild(id, 'driverEval');
    },
    goChild: function goChild(id, tableName) {
      this.$emit('child-go', id, tableName);
    },
    initDriverFormData: function initDriverFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      if (paramData.carImage) {
        paramData.carImageArray = JSON.parse(paramData.carImage);
      } else {
        paramData.carImageArray = [];
      }
      if (paramData.insurancePolicyImage) {
        paramData.insurancePolicyImageArray = JSON.parse(paramData.insurancePolicyImage);
      } else {
        paramData.insurancePolicyImageArray = [];
      }
      this.driverFormData = paramData;
      console.log(paramData);
      if (typeof this.$refs['formDriverDataVerify'] !== 'undefined') {
        this.$refs['formDriverDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(driverFormData) {
      var saveFormData = JSON.parse(JSON.stringify(driverFormData));
      if (saveFormData.carImageArray) {
        saveFormData.carImage = JSON.stringify(saveFormData.carImageArray);
      }
      if (saveFormData.insurancePolicyImageArray) {
        saveFormData.insurancePolicyImage = JSON.stringify(saveFormData.insurancePolicyImageArray);
      }
      return saveFormData;
    },
    driverEdit: function driverEdit(id) {
      var _this8 = this;
      this.$api[this.pageConfig.queryDriverAuditFunName]({
        userId: id,
        sortField: 'create_time',
        category: 'Apply',
        limit: 1
      }).then(function (res) {
        _this8.initDriverFormData(res.data[0]);
        _this8.editDialogTitle = _this8.pageConfig.editPageName + '维护';
        _this8.editDriverDialogShow = true;
      });
    },
    query: function query() {
      var _this9 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryDriverFunName](this.searchForm).then(function (res) {
        _this9.tableData = res.data || [];
        _this9.totalCount = res.count;
        _this9.queryLoading = false;
      });
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    uploadCardFrontImage: function uploadCardFrontImage(_ref2) {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref2.file;
              _this10.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  var identityCardImageFront;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this10.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        identityCardImageFront = _context.sent;
                        _this10.$set(_this10.driverFormData, 'identityCardImageFront', identityCardImageFront);
                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    uploadCardBackImage: function uploadCardBackImage(_ref4) {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var file;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              file = _ref4.file;
              _this11.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res) {
                  var identityCardImageBack;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return _this11.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        identityCardImageBack = _context3.sent;
                        _this11.$set(_this11.driverFormData, 'identityCardImageBack', identityCardImageBack);
                      case 4:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x2) {
                  return _ref5.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    uploadDrivingLicenceImage: function uploadDrivingLicenceImage(_ref6) {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var file;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              file = _ref6.file;
              _this12.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(res) {
                  var drivingLicenceImage;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return _this12.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        drivingLicenceImage = _context5.sent;
                        _this12.$set(_this12.driverFormData, 'drivingLicenceImage', drivingLicenceImage);
                      case 4:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x3) {
                  return _ref7.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    uploadVehicleLicenseImage: function uploadVehicleLicenseImage(_ref8) {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var file;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              file = _ref8.file;
              _this13.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(res) {
                  var vehicleLicense;
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return _this13.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        vehicleLicense = _context7.sent;
                        _this13.$set(_this13.driverFormData, 'vehicleLicense', vehicleLicense);
                      case 4:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x4) {
                  return _ref9.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    uploadCarsImage: function uploadCarsImage(_ref10) {
      var _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var file;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              file = _ref10.file;
              _this14.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(res) {
                  var filePath;
                  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.next = 2;
                        return _this14.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        filePath = _context9.sent;
                        _this14.driverFormData.carImageArray.push({
                          uid: file.uid,
                          url: filePath
                        });
                      case 4:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee9);
                }));
                return function (_x5) {
                  return _ref11.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    uploadPolicyImage: function uploadPolicyImage(_ref12) {
      var _this15 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var file;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              file = _ref12.file;
              _this15.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(res) {
                  var filePath;
                  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                    while (1) switch (_context11.prev = _context11.next) {
                      case 0:
                        _context11.next = 2;
                        return _this15.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        filePath = _context11.sent;
                        _this15.driverFormData.insurancePolicyImageArray.push({
                          uid: file.uid,
                          url: filePath
                        });
                      case 4:
                      case "end":
                        return _context11.stop();
                    }
                  }, _callee11);
                }));
                return function (_x6) {
                  return _ref13.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    removeIdentityCardImageFrontFile: function removeIdentityCardImageFrontFile() {
      this.driverFormData.identityCardImageFront = '';
    },
    removeIdentityCardImageBackFile: function removeIdentityCardImageBackFile() {
      this.driverFormData.identityCardImageBack = '';
    },
    removeDrivingLicenceFile: function removeDrivingLicenceFile() {
      this.driverFormData.drivingLicenceImage = '';
    },
    removeVehicleLicenseFile: function removeVehicleLicenseFile() {
      this.driverFormData.drivingLicenceImage = '';
    },
    previewFile: function previewFile(path) {
      window.open(path);
    },
    previewArrayImageFile: function previewArrayImageFile(file) {
      window.open(file.url);
    },
    removeCarsImageFile: function removeCarsImageFile(file, fileList) {
      for (var i in this.driverFormData.carImageArray) {
        if (this.driverFormData.carImageArray[i].uid === file.uid) {
          this.driverFormData.carImageArray.splice(i, 1);
        }
      }
    },
    removePolicyImageFile: function removePolicyImageFile(file, fileList) {
      for (var i in this.driverFormData.insurancePolicyImageArray) {
        if (this.driverFormData.insurancePolicyImageArray[i].uid === file.uid) {
          this.driverFormData.insurancePolicyImageArray.splice(i, 1);
        }
      }
    },
    submitDriverFormData: function submitDriverFormData() {
      var _this16 = this;
      console.log(this.driverFormData, "this.driverFormData");
      this.$refs['formDriverDataVerify'].validate(function (valid) {
        console.log(valid, "=====");
        if (valid) {
          var submitData = _this16.driverFormData;
          if (_this16.driverFormData.id) {
            _this16.$api[_this16.pageConfig.addDriverAuditFunName](_this16.saveFormDataProcess(submitData)).then(function (res) {
              if (res.data) {
                _this16.$message.success('编辑成功');
                _this16.initDriverFormData(_this16.emptyDriverFormData);
                _this16.editDriverDialogShow = false;
                _this16.query();
              } else {
                _this16.$message.error('编辑失败');
              }
            });
          } else {
            _this16.$api[_this16.pageConfig.addFunName](_this16.saveFormDataProcess(submitData)).then(function (res) {
              if (res.data) {
                _this16.$message.success('新增成功');
                _this16.initDriverFormData(_this16.emptyDriverFormData);
                _this16.editDriverDialogShow = false;
                _this16.query();
              } else {
                _this16.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    submitSuccessFormData: function submitSuccessFormData() {
      var _this17 = this;
      if (this.successData.successCarTeam) {
        this.$api[this.pageConfig.successDriverFunNane](this.successData.successRowId, this.successData.successCarTeam).then(function (res) {
          _this17.$message.success('操作成功');
          _this17.successDialogShow = false;
          _this17.query();
        });
      } else {
        this.$message.error('请选择车队');
      }
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    closeSuccessDialogShow: function closeSuccessDialogShow() {
      this.successData.successCarTeam = '';
      this.successData.successRowId = '';
      this.rowCarInfo = {};
      this.successDialogShow = false;
    },
    closeDriverEditDialogShow: function closeDriverEditDialogShow() {
      this.editDialogTitle = '';
      this.editDriverDialogShow = false;
      this.initDriverFormData(this.emptyDriverFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};